import { render } from "./EducationComponentJa.vue?vue&type=template&id=626fcaab&scoped=true"
import script from "./EducationComponentJa.vue?vue&type=script&lang=js"
export * from "./EducationComponentJa.vue?vue&type=script&lang=js"

import "./EducationComponentJa.vue?vue&type=style&index=0&id=626fcaab&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626fcaab"]])

export default __exports__